import { render, staticRenderFns } from "./StopAttachment.vue?vue&type=template&id=4ae0f75a&scoped=true&"
import script from "./StopAttachment.vue?vue&type=script&lang=js&"
export * from "./StopAttachment.vue?vue&type=script&lang=js&"
import style0 from "./StopAttachment.vue?vue&type=style&index=0&id=4ae0f75a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae0f75a",
  null
  
)

export default component.exports